import {MenuItem} from '@gatewee/components';

export const menuItems: MenuItem[] = [
  {
    title: 'nav.menu.home',
    icon: '@phi.house',
    route: '/panel',
  },
  {
    title: 'nav.menu.dailyOperations',
    icon: '@phi.chart-line-up',
    subMenu: [
      {
        title: 'nav.menu.transactions',
        route: '/panel/transactions',
      },
      {
        title: 'nav.menu.withdrawals',
        route: '/panel/withdrawals',
      },
      {
        title: 'nav.menu.refunds',
        route: '/panel/refunds',
      },
      {
        title: 'nav.menu.chargebacks',
        route: '/panel/chargebacks',
      },
      {
        title: 'nav.menu.reports',
        route: '/panel/reports',
      },
    ],
  },
  {
    title: 'nav.menu.commercialBase',
    icon: '@phi.briefcase',
    subMenu: [
      {
        title: 'nav.menu.clients',
        route: '/panel/clients',
      },
    ],
  },
  {
    title: 'nav.menu.billingRecurring',
    icon: '@phi.tag',
    subMenu: [
      {
        title: 'nav.menu.invoices',
        route: '/panel/invoices',
      },
      {
        title: 'nav.menu.checkouts',
        route: '/panel/checkouts',
      },
      {
        title: 'nav.menu.subscriptions',
        route: '/panel/subscriptions',
        subsubMenu: [
          {
            title: 'nav.menu.subscriptionsPlans',
            route: '/panel/subscriptions-plans',
          },
        ],
      },
    ],
  },
  {
    title: 'nav.menu.feesAdjustments',
    icon: '@phi.percent',
    subMenu: [
      {
        title: 'nav.menu.myFees',
        route: '/panel/my-fees',
      },
    ],
  },
  {
    title: 'nav.menu.settings',
    icon: '@phi.gear-six',
    subMenu: [
      {
        title: 'nav.menu.users',
        route: '/panel/settings/users',
      },
      {
        title: 'nav.menu.receivingAccounts',
        route: '/panel/settings/bank-accounts',
      },
      {
        title: 'nav.menu.pixKeys',
        route: '/panel/recipients/pix-keys',
      },
      {
        title: 'nav.menu.whatsapp',
        route: '/panel/settings/whatsapp',
      },
    ],
  },
  {
    title: 'nav.menu.developers',
    icon: '@phi.code',
    subMenu: [
      {
        title: 'nav.menu.apiKeys',
        route: '/panel/recipients/keys',
      },
      {
        title: 'nav.menu.apiDocumentation',
        route: '/documentation',
      },
    ],
  },
  {
    title: 'nav.menu.helpSupport',
    icon: '@phi.lifebuoy',
    subMenu: [
      {
        title: 'nav.menu.supportTickets',
        route: '/panel/support-tickets',
      },
      {
        title: 'nav.menu.privacyDataRequests',
        route: '/panel/support-tickets/new',
      },
    ],
  },
];
